import { IconComponent } from 'models/icons';

/**
 * This file was auto-generated using svgr
 *
 * Source file: assets/icons/gizmo.svg
 */
const IconGizmo: IconComponent = ({
  size = 24,
  color = 'white',
  className,
  svgElementProps: props = {},
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    color={color}
    className={className}
    {...props}
  >
    <path
      d="M18.127 10.45L12.68 7.224a1.392 1.392 0 00-1.39 0L5.843 10.45c-.213.126-.39.308-.513.527a1.45 1.45 0 00-.182.72v6.467c.003.251.068.499.19.717.121.218.295.4.505.53l5.447 3.227a1.31 1.31 0 001.39 0l5.447-3.242c.213-.126.39-.308.512-.527.122-.22.185-.468.183-.72v-6.44a1.486 1.486 0 00-.184-.725 1.435 1.435 0 00-.511-.534zm-6.295-2.239a.249.249 0 01.146-.031c.05.003.099.014.146.031l5.03 2.994-5.176 3.059-5.177-3.06 5.031-2.993zm-5.447 10.21a.314.314 0 01-.146-.25v-5.986l5.18 3.077v6.136l-5.034-2.976zm11.164 0l-5.03 2.992v-6.15l5.176-3.078v5.97a.303.303 0 01-.135.271l-.01-.004z"
      fill="currentColor"
    />
    <path
      d="M4.473 23.128a.513.513 0 00-.175-.525.48.48 0 00-.17-.086l-2.484-.672 3.752-2.586.464-.32a.492.492 0 00.225-.32.514.514 0 00-.07-.386.493.493 0 00-.322-.215.475.475 0 00-.373.092l-4.215 2.907.33-2.62a.51.51 0 00-.225-.53.477.477 0 00-.684.204.509.509 0 00-.051.197l-.473 3.711a.574.574 0 000 .086v.076c.004.022.01.044.018.065v.03c.01.03.025.057.043.083a.698.698 0 00.06.075l.025.02c.016.015.032.03.05.042h.013l.033.019h.021c.025.011.051.02.077.028l3.52.961a.472.472 0 00.374-.037.489.489 0 00.237-.299zM22.992 17.822a.477.477 0 00-.321.19.505.505 0 00-.095.37l.337 2.617-4.222-2.895a.48.48 0 00-.376-.099.48.48 0 00-.326.216.508.508 0 00-.068.392.509.509 0 00.232.32l.463.32 3.759 2.577-2.484.683a.478.478 0 00-.313.227.507.507 0 00.184.7.474.474 0 00.382.035l3.517-.966.076-.03h.02l.034-.018c.017 0 .036-.026.053-.04l.021-.02a.557.557 0 00.061-.076.376.376 0 00.044-.085l.011-.032a.594.594 0 00.017-.065v-.076a.549.549 0 000-.083l-.482-3.71a.509.509 0 00-.17-.339.474.474 0 00-.354-.113zM8.878 3.76a.48.48 0 00.684.045l1.93-1.743v5.217c0 .133.051.26.142.353a.48.48 0 00.688 0 .507.507 0 00.142-.353V2.062l1.93 1.743a.485.485 0 00.356.135.477.477 0 00.343-.17.506.506 0 00.119-.371.505.505 0 00-.177-.345L12.298.59a.767.767 0 00-.067-.049h-.02l-.032-.018h-.016l-.06-.022h-.031a.636.636 0 00-.092 0 .646.646 0 00-.094 0h-.03l-.061.022h-.015l-.033.018h-.019l-.068.05-2.736 2.462a.501.501 0 00-.165.343.513.513 0 00.119.363z"
      fill="currentColor"
    />
  </svg>
);

export default IconGizmo;
